import { Trophy, Clock, Users, Check, X } from 'lucide-react';

export const WeeklyChallenge = ({
  weeklyChallenge,
  weeklyCompleted,
  shakeWeekly,
  getTimeRemaining,
  weeklyChallengeCount,
  completeWeeklyChallenge,
  daysUntilNextWeekly,
}) => {
  return (
    <div
      className={`relative bg-gradient-to-br from-yellow-500 to-orange-600 p-3 sm:p-4 md:p-6 border-2 sm:border-3 md:border-4 border-yellow-400 ${shakeWeekly ? 'animate-shake' : ''} transition-all duration-300 hover:scale-105 hover:border-yellow-300`}
      style={{ zIndex: 0, boxShadow: '0 4px 6px rgba(0,0,0,0.3)' }}
      onMouseEnter={(e) => e.currentTarget.style.boxShadow = '0 20px 40px rgba(234, 179, 8, 0.6)'}
      onMouseLeave={(e) => e.currentTarget.style.boxShadow = '0 4px 6px rgba(0,0,0,0.3)'}
    >
      <div className="relative z-10">
        <div className="flex flex-col sm:flex-row sm:items-start justify-between mb-3 sm:mb-4 gap-2 sm:gap-3">
          <div className="flex items-center gap-2 sm:gap-3">
            <div className="bg-black p-2 sm:p-3 border-2 border-yellow-300">
              <Trophy className="text-yellow-400" size={20} />
            </div>
            <h2 className="text-xl sm:text-2xl md:text-3xl font-black text-black uppercase tracking-tight">WEEKLY CHALLENGE</h2>
          </div>

          <div className="flex flex-col sm:items-end gap-1">
            <div className="flex items-center gap-2 flex-wrap justify-end">
              {!weeklyCompleted && getTimeRemaining('weekly') && !getTimeRemaining('weekly').expired && (
                <div className={`px-2 sm:px-3 py-1 border-2 ${getTimeRemaining('weekly').isWarning
                  ? 'bg-red-600 border-red-400 animate-pulse'
                  : 'bg-black border-yellow-300'
                  }`}>
                  <div className="flex items-center gap-1">
                    <Clock size={14} className={getTimeRemaining('weekly').isWarning ? 'text-white' : 'text-yellow-400'} />
                    <span className={`font-black text-xs uppercase ${getTimeRemaining('weekly').isWarning ? 'text-white' : 'text-yellow-400'}`}>
                      {getTimeRemaining('weekly').days > 0
                        ? `${getTimeRemaining('weekly').days}D ${getTimeRemaining('weekly').hours}H`
                        : `${getTimeRemaining('weekly').hours}H`
                      }
                    </span>
                  </div>
                </div>
              )}
              <span className="bg-black text-yellow-400 px-2 sm:px-3 md:px-4 py-1 font-black uppercase text-xs sm:text-sm tracking-wider border-2 border-yellow-300">
                {weeklyChallenge.category}
              </span>
            </div>
            <span className="text-black text-xs font-black">
              +{weeklyChallenge.points} POINTS
            </span>
          </div>
        </div>

        <p className="text-black text-base sm:text-lg md:text-xl font-black leading-tight mb-3 sm:mb-4">{weeklyChallenge.text}</p>

        {weeklyChallengeCount > 0 && (
          <div className="mb-3 flex items-center gap-2 text-black">
            <Users size={16} />
            <span className="font-bold text-sm">
              {weeklyChallengeCount} {weeklyChallengeCount === 1 ? 'person' : 'people'} sent this
            </span>
          </div>
        )}

        {!weeklyCompleted ? (
          <div className="flex flex-col sm:flex-row gap-2 sm:gap-3 md:gap-4 mt-3 sm:mt-4">
            <button
              onClick={() => completeWeeklyChallenge(true)}
              className="flex-1 bg-black hover:bg-yellow-900 text-yellow-400 py-3 sm:py-4 font-black text-base sm:text-lg md:text-xl flex items-center justify-center gap-2 transition-all duration-200 uppercase tracking-wider border-2 sm:border-3 border-yellow-300 active:scale-95 hover:shadow-lg hover:shadow-yellow-500/50"
            >
              <Check size={20} />
              SENT IT
            </button>
            <button
              onClick={() => completeWeeklyChallenge(false)}
              className="flex-1 bg-gray-800 hover:bg-gray-700 text-gray-400 py-3 sm:py-4 font-black text-base sm:text-lg md:text-xl flex items-center justify-center gap-2 transition-all duration-200 uppercase tracking-wider border-2 sm:border-3 border-gray-700 active:scale-95 hover:shadow-lg hover:shadow-gray-700/50"
            >
              <X size={20} />
              BITCHED OUT
            </button>
          </div>
        ) : (
          <div className="bg-black border-2 sm:border-3 border-yellow-300 py-3 sm:py-4 text-center font-black text-yellow-400 text-base sm:text-lg md:text-xl uppercase tracking-wider mt-3 sm:mt-4">
            ✓ WEEKLY COMPLETE
            {daysUntilNextWeekly > 0 && (
              <div className="text-xs sm:text-sm text-yellow-300 mt-2">
                Next challenge in {daysUntilNextWeekly} day{daysUntilNextWeekly !== 1 ? 's' : ''}
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};
